import { render } from "./AchievementModal.vue?vue&type=template&id=1c1dd288"
import script from "./AchievementModal.vue?vue&type=script&lang=js"
export * from "./AchievementModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__